import App from "App";
import { useEffect } from "react";

import { sessionState, useChatSession } from "@chainlit/react-client";
import { useRecoilValue } from "recoil";

const userEnv = {};

export default function AppWrapper() {
  const { connect } = useChatSession();
  const session = useRecoilValue(sessionState);
  useEffect(() => {
    if (session?.socket.connected) {
      return;
    }
    // fetch("http://localhost:8000/custom-auth", { credentials: "include" }).then(
    //   () => {
    //     connect({
    //       userEnv,
    //     });
    //   }
    // );
    fetch("https://ag.digitalya.co/custom-auth", {
      credentials: "include",
    }).then(() => {
      connect({
        userEnv,
      });
    });
  }, [connect]);

  return <App />;
}
